<template>
	<section class="pre-footer">
		<div class="row small-row">
			<div class="columns column12 align-center">
				<h2>{{ footerSection.header }}</h2>
				<div v-if="footerSection.content" v-parse-links v-html="footerSection.content" />
			</div>
		</div>
		<picture>
			<source v-if="footerSection.imageWebp" :srcset="footerSection.imageWebp" type="image/webp" />
			<source :srcset="footerSection.image" />
			<img :src="footerSection.image" class="bg-image" loading="lazy" :alt="footerSection.imageAlt" />
		</picture>
	</section>
</template>

<script setup>
defineProps({
	footerSection: { type: Object, default: () => {} },
});
</script>

<style lang="scss" scoped>
.pre-footer {
	position: relative;
	color: #fff;

	h2,
	h3,
	h4 {
		color: #fff;
	}

	&::before {
		position: absolute;
		inset: 0;
		content: '';
		display: block;
		z-index: 2;
		background: rgb(0 0 0 / 50%);
	}

	.column12 {
		background: none;
		color: #fff;
		padding: 50px;
		margin: 200px auto;
		z-index: 3;
	}
}

.bg-image {
	position: absolute;
	inset: 0;
	height: 100%;
	width: 100%;
	object-fit: cover;
	z-index: 1;
}
</style>
